<template>
    <div class="ideas-view">
        <v-container class="text-primary px-0">
            <v-row>
                <v-col sm="4" md="4" lg="3" xl="2">
                    <v-btn @click="openIdeaDialog(null)"
                           class="w-100"
                           color="lonely"
                           variant="flat">Создать идею</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-expansion-panels v-model="ideasPanels"
                                        variant="inset"
                                        class="text-primary"
                                        multiple>
                        <draggable class="list-group"
                                   :component-data="componentData"
                                   v-model="ideasCopy"
                                   v-bind="dragOptions"
                                   item-key="id"
                                   @change="onOrderChanged">
                            <template #item="{ element }">
                                <v-expansion-panel class="text-primary" :value="element.id">
                                    <v-expansion-panel-title>
                                        {{ element.name }}
                                        <template v-slot:actions="{ expanded }">
                                            <template v-if="expanded">
                                                <v-tooltip location="bottom"
                                                           text="Редактировать">
                                                    <template v-slot:activator="{ props }">
                                                        <v-btn @click.stop="openIdeaDialog(element)"
                                                               density="comfortable"
                                                               variant="text"
                                                               color="lonely"
                                                               v-bind="props"
                                                               icon="mdi-pen"
                                                               class="mr-2" />
                                                    </template>
                                                </v-tooltip>
                                                <v-tooltip location="bottom"
                                                           text="Удалить">
                                                    <template v-slot:activator="{ props }">
                                                        <v-btn @click.stop="openIdeaDeleteDialog(element)"
                                                               density="comfortable"
                                                               variant="text"
                                                               color="error"
                                                               v-bind="props"
                                                               icon="mdi-trash-can-outline"
                                                               class="mr-4" />
                                                    </template>
                                                </v-tooltip>
                                            </template>
                                            <v-btn density="comfortable"
                                                   variant="text"
                                                   :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
                                        </template>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="pre-space">
                                        <i :class="element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                                           @click="element.fixed = !element.fixed"
                                           aria-hidden="true"></i>
                                        {{ element.text }}
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </template>
                        </draggable>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <create-edit-idea-dialog v-if="showIdeaDialog" @hide="showIdeaDialog = false" :idea="ideaToEdit" />
        <delete-idea-confirm-dialog v-if="showIdeaDeleteModal" @hide="showIdeaDeleteModal = false" :idea="ideaToDelete"></delete-idea-confirm-dialog>
    </div>
</template>

<script>
    import CreateEditIdeaDialog from "@/components/client/ideas/CreateEditIdeaDialog.vue";
    import DeleteIdeaConfirmDialog from "@/components/client/ideas/DeleteIdeaConfirmDialog.vue";
    import draggable from "vuedraggable";
    import _debounce from "lodash/debounce";

    export default {
        components: {
            CreateEditIdeaDialog,
            DeleteIdeaConfirmDialog,
            draggable
        },

        data() {
            return {
                ideasPanels: [],

                ideaToEdit: null,
                showIdeaDialog: false,

                ideaToDelete: null,
                showIdeaDeleteModal: false,

                ideasCopy: null
            };
        },

        created() {
            this.$store.dispatch("loadIdeas")
                .then(() => this.ideasPanels = this.ideas.map(e => e.id));
        },

        computed: {
            ideas() {
                return this.$store.state.ideas;
            },

            componentData() {
                return {
                    tag: "template",
                    type: "transition-group"
                };
            },

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },

        watch: {
            ideas(newValue, oldValue) {
                if (oldValue.length < newValue.length) {
                    this.ideasPanels.push(newValue[0].id);
                } else {
                    this.ideasPanels = this.ideasPanels.filter(id => newValue.map(e => e.id).includes(id));
                }

                this.ideasCopy = JSON.parse(JSON.stringify(newValue));
            }
        },

        methods: {
            openIdeaDialog(idea) {
                this.ideaToEdit = idea;
                this.showIdeaDialog = true;
            },

            openIdeaDeleteDialog(idea) {
                this.ideaToDelete = idea;
                this.showIdeaDeleteModal = true;
            },

            onOrderChanged() {
                this.saveOrder(this.ideasCopy, this);
            },

            saveOrder: _debounce((ideas, self) => self.$store.dispatch("saveIdeasOrder", ideas)
                .then(() => self.$store.dispatch("loadIdeas")), 600)
        }
    };
</script>

<style lang="scss">
    .ideas-view {
        .pre-space {
            white-space: pre;
        }

        .list-group {
            width: 100%;
        }
    }
</style>